export const resolveDescription = (options, code) =>
  options?.find((option) => option.Code === code)?.Description || code || '';

export const calculateAge = (born) => {
  if (!born) return '';

  const dob = new Date(born);
  if (Number.isNaN(dob.getTime())) return '';

  const today = new Date();
  let age = today.getFullYear() - dob.getFullYear();
  const monthDiff = today.getMonth() - dob.getMonth();

  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
    age -= 1;
  }

  return age >= 0 ? age : '';
};
